import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import HttpApi from 'i18next-http-backend'
// To load the translation files

const options: InitOptions = {
  debug: process.env.NODE_ENV !== 'production',
  fallbackLng: 'en',
  supportedLngs: ['en', 'es'],
  interpolation: {
    escapeValue: false,
  },
  ns: ['translation'], // Names of the translation files
  backend: {
    loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
  },
  detection: {
    order: ['localStorage'],
    lookupLocalStorage: 'lng',
    //checkWhitelist: true,
  },
  saveMissing: true,
  saveMissingTo: 'all',
}
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('lng', lng)
})
i18n.use(HttpApi).use(LanguageDetector).use(initReactI18next).init(options)
//resources,
//lng: 'en', //default language)
export default i18n
